<template>
  <v-chip small outlined :color="color">
    {{ $t(labelKey) }}
  </v-chip>
</template>

<script>
import { baTypeConfig } from "../../../data/betriebsanweisungTypes";

export default {
  name: "betriebsanweisungType",
  props: ["item"],
  computed: {
    cfg() {
      return baTypeConfig(this.item.type);
    },
    color() {
      return this.cfg.color;
    },
    labelKey() {
      return this.cfg.labelKey;
    },
  },
};
</script>
